import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../services/api"; // Assuming you have an API service setup

const EditTaxPage = () => {
    const { id: businessId, taxId } = useParams(); // Extract businessId and taxId from the URL
    const [formData, setFormData] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    // Fetch data for the tax record on component mount
    useEffect(() => {
        const fetchTaxData = async () => {
            try {
                const response = await api.get(`/tax-info/edit/${businessId}/${taxId}`);
                setFormData(response.data || {});
            } catch (err) {
                console.error("Error fetching tax information:", err);
                setError("Failed to fetch tax information.");
            } finally {
                setLoading(false);
            }
        };

        fetchTaxData();
    }, [businessId, taxId]);

    // Handle input change
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await api.put(`/tax-info/edit/${businessId}/${taxId}`, formData);
            console.log("Tax information updated successfully!");
            navigate(-1); // Go back to the previous page
        } catch (err) {
            console.error("Error updating tax information:", err);
            alert("Failed to update tax information.");
        }
    };

    if (loading) return <p>Loading tax information...</p>;
    if (error) return <p>{error}</p>;

    return (
        <div className="fed-tax-edit-page">
            <h4 style={{textAlign:"center"}}>Edit Tax Information for {formData.state || "Unknown State"}</h4>
            <form onSubmit={handleSubmit} className="fed-edit-form">
                {formData.withholding_account_number !== null && (
                    <label>
                        Withholding Account Number:
                        <input
                            type="text"
                            name="withholding_account_number"
                            value={formData.withholding_account_number || ""}
                            onChange={handleChange}
                        />
                    </label>
                )}
                {formData.uia_account_number !== null && (
                    <label>
                        UIA Account Number:
                        <input
                            type="text"
                            name="uia_account_number"
                            value={formData.uia_account_number || ""}
                            onChange={handleChange}
                        />
                    </label>
                )}
                {formData.unemployment_tax_rate !== null && (
                    <label>
                        Unemployment Tax Rate:
                        <input
                            type="number"
                            step="0.01"
                            name="unemployment_tax_rate"
                            value={formData.unemployment_tax_rate || ""}
                            onChange={handleChange}
                        />
                    </label>
                )}
                {formData.di_handling !== null && (
                    <label>
                        DI Handling:
                        <select
                            name="di_handling"
                            value={formData.di_handling || ""}
                            onChange={handleChange}
                        >
                            <option value="">Select</option>
                            <option value="noWithdraw">No Withdraw</option>
                            <option value="withdraw">Withdraw</option>
                        </select>
                    </label>
                )}
                {formData.di_contribution !== null && (
                    <label>
                        DI Contribution:
                        <select
                            name="di_contribution"
                            value={formData.di_contribution || ""}
                            onChange={handleChange}
                        >
                            <option value="">Select</option>
                            <option value="noContribute">No Contribute</option>
                            <option value="contribute">Contribute</option>
                        </select>
                    </label>
                )}
                {formData.employer_rate !== null && (
                    <label>
                        Employer Rate (%):
                        <input
                            type="number"
                            step="0.01"
                            name="employer_rate"
                            value={formData.employer_rate || ""}
                            onChange={handleChange}
                        />
                    </label>
                )}
                {formData.employee_share !== null && (
                    <label>
                        Employee Share (%):
                        <input
                            type="number"
                            step="0.01"
                            name="employee_share"
                            value={formData.employee_share || ""}
                            onChange={handleChange}
                        />
                    </label>
                )}
                {formData.employer_share !== null && (
                    <label>
                        Employer Share (%):
                        <input
                            type="number"
                            step="0.01"
                            name="employer_share"
                            value={formData.employer_share || ""}
                            onChange={handleChange}
                        />
                    </label>
                )}
                {formData.istaxing_di !== null && (
                    <label>
                        Is Taxing DI:
                        <select
                            name="istaxing_di"
                            value={formData.istaxing_di || ""}
                            onChange={handleChange}
                        >
                            <option value="">Select</option>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                    </label>
                )}
                {formData.di_account !== null && (
                    <label>
                        DI Account:
                        <input
                            type="text"
                            name="di_account"
                            value={formData.di_account || ""}
                            onChange={handleChange}
                        />
                    </label>
                )}
                <button>
                    Save Changes
                </button>
            </form>
        </div>
    );
};

export default EditTaxPage;



// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import api from "../services/api"; // Assuming you have an API service setup

// const EditTaxPage = () => {
//     const {id: businessId, taxId } = useParams(); // Extract businessId and state from the URL
//     const [formData, setFormData] = useState({
//         state: "",
//         withholding_account_number: "",
//         uia_account_number: "",
//         unemployment_tax_rate: "",
//         di_handling: "",
//         di_contribution: "",
//         employer_rate: "",
//         employee_share: "",
//         employer_share: "",
//         istaxing_di: "",
//         di_account: "",
//     });
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const navigate = useNavigate();

//     // Fetch data for the state on component mount
//     useEffect(() => {
//         const fetchTaxData = async () => {
//             try {
//                 const response = await api.get(`/tax-info/edit/${businessId}/${taxId}`);
//                 setFormData(response.data || {});
//             } catch (err) {
//                 console.error("Error fetching tax information:", err);
//                 setError("Failed to fetch tax information.");
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchTaxData();
//     }, [businessId, taxId]);

//     // Handle input change
//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData((prev) => ({ ...prev, [name]: value }));
//     };

//     // Handle form submission
//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             await api.put(`/tax-info/edit/${businessId}/${taxId}`, formData);
//             alert("Tax information updated successfully!");
//             navigate(-1); // Go back to the previous page
//         } catch (err) {
//             console.error("Error updating tax information:", err);
//             alert("Failed to update tax information.");
//         }
//     };

//     if (loading) return <p>Loading tax information...</p>;
//     if (error) return <p>{error}</p>;

//     return (
//         <div style={{ padding: "20px" }}>
//             <h2>Edit Tax Information for {formData.state}</h2>
//             <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
//                 <label>
//                     Withholding Account Number:
//                     <input
//                         type="text"
//                         name="withholdingAccountNumber"
//                         value={formData.withholding_account_number || ""}
//                         onChange={handleChange}
//                     />
//                 </label>
//                 <label>
//                     UIA Account Number:
//                     <input
//                         type="text"
//                         name="uiaAccountNumber"
//                         value={formData.uia_account_number || ""}
//                         onChange={handleChange}
//                     />
//                 </label>
//                 <label>
//                     Unemployment Tax Rate:
//                     <input
//                         type="number"
//                         step="0.01"
//                         name="unemploymentTaxRate"
//                         value={formData.unemployment_tax_rate || ""}
//                         onChange={handleChange}
//                     />
//                 </label>
//                 <label>
//                     DI Handling:
//                     <select
//                         name="diHandling"
//                         value={formData.di_handling || ""}
//                         onChange={handleChange}
//                     >
//                         <option value="">Select</option>
//                         <option value="noWithdraw">No Withdraw</option>
//                         <option value="withdraw">Withdraw</option>
//                     </select>
//                 </label>
//                 <label>
//                     DI Contribution:
//                     <select
//                         name="diContribution"
//                         value={formData.di_contribution || ""}
//                         onChange={handleChange}
//                     >
//                         <option value="">Select</option>
//                         <option value="noContribute">No Contribute</option>
//                         <option value="contribute">Contribute</option>
//                     </select>
//                 </label>
//                 <label>
//                     Employer Rate (%):
//                     <input
//                         type="number"
//                         step="0.01"
//                         name="employerRate"
//                         value={formData.employer_rate || ""}
//                         onChange={handleChange}
//                     />
//                 </label>
//                 <label>
//                     Employee Share (%):
//                     <input
//                         type="number"
//                         step="0.01"
//                         name="employeeShare"
//                         value={formData.employee_share || ""}
//                         onChange={handleChange}
//                     />
//                 </label>
//                 <label>
//                     Employer Share (%):
//                     <input
//                         type="number"
//                         step="0.01"
//                         name="employerShare"
//                         value={formData.employer_share || ""}
//                         onChange={handleChange}
//                     />
//                 </label>
//                 <label>
//                     Is Taxing DI:
//                     <select
//                         name="istaxingDi"
//                         value={formData.istaxing_di || ""}
//                         onChange={handleChange}
//                     >
//                         <option value="">Select</option>
//                         <option value="1">Yes</option>
//                         <option value="0">No</option>
//                     </select>
//                 </label>
//                 <label>
//                     DI Account:
//                     <input
//                         type="text"
//                         name="diAccount"
//                         value={formData.di_account || ""}
//                         onChange={handleChange}
//                     />
//                 </label>
//                 <button type="submit" style={{ padding: "10px", backgroundColor: "teal", color: "white", border: "none", borderRadius: "5px" }}>
//                     Save Changes
//                 </button>
//             </form>
//         </div>
//     );
// };

// export default EditTaxPage;
